import Vue from 'vue';
import ElementUI from 'element-ui';
import './element-color/theme/index.css';
import Antd from 'ant-design-vue';
import 'ant-design-vue/dist/antd.less'
import App from './App.vue';
import router from './router';

//引入svg

import './icon/index.js'

Vue.config.productionTip = false;
// entry
// import microApp from '@micro-zoe/micro-app'

// microApp.start()
import "@/text/text.less";
// import "@/view/day.less";
Vue.use(ElementUI);
Vue.use(Antd);
new Vue({
  el: '#app',
  router,
  render: h => h(App)
});